import { Component } from '@angular/core';

@Component({
  selector: 'add-user-placeholder',
  templateUrl: './add-user-placeholder.component.html',
  styleUrl: './add-user-placeholder.component.scss',
  standalone: false,
})
export class AddUserPlaceholderComponent {}
